import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DisplayAndSelectModel } from '@bo-client/shared/components/display-and-selec-option/display-and-select.model';
import { MeteringConceptModel } from '@bo-client/activation-management/shared/models/meteringConceptModel';

@Injectable({
  providedIn: 'root'
})
export class DisplayAndSelectService {
  public form = new FormGroup({}, { updateOn: 'submit' });

  constructor() {}

  meteringConceptToDisplayAndSelect(meteringConceptList: MeteringConceptModel[]): DisplayAndSelectModel[] {
    const displayAndSelectList: DisplayAndSelectModel[] = new Array<DisplayAndSelectModel>();
    meteringConceptList.forEach((ele) => {
      const newDisplayAndSelect: DisplayAndSelectModel = new DisplayAndSelectModel();
      newDisplayAndSelect.itemId = ele.id;
      newDisplayAndSelect.displayName = ele.name;
      newDisplayAndSelect.description = ele.description;
      newDisplayAndSelect.imgUrl = ele.imageDocument.url;
      displayAndSelectList.push(newDisplayAndSelect);
    });
    return displayAndSelectList;
  }

  selectedMeteringConceptToDisplay(
    itemId: number,
    displayAndSelectList: DisplayAndSelectModel[]
  ): DisplayAndSelectModel {
    const idx = displayAndSelectList.findIndex((ele) => ele.itemId === itemId);
    return idx !== -1 ? displayAndSelectList[idx] : null;
  }

  sortMeteringConceptListBySortPosition(list: MeteringConceptModel[]) {
    return list.sort((a, b) =>
      a.sortPosition < b.sortPosition ? -1 : a.sortPosition > b.sortPosition ? 1 : 0
    );
  }
}
